module.exports = __webpack_public_path__ + "img/logo-specialist.e7cfad0e.svg";